var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"additional"},[_c('div',{staticClass:"additional-header"},[_vm._v(_vm._s(_vm.$t("ORDER.PAY_BY_PAYPAL")))]),_c('div',{attrs:{"id":"pp"}})]),_c('modal-loader',{model:{value:(_vm.modalLoader),callback:function ($$v) {_vm.modalLoader=$$v},expression:"modalLoader"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }